import { render, staticRenderFns } from "./EventTicket.vue?vue&type=template&id=05c65718&scoped=true&"
import script from "./EventTicket.vue?vue&type=script&lang=js&"
export * from "./EventTicket.vue?vue&type=script&lang=js&"
import style0 from "./EventTicket.vue?vue&type=style&index=0&id=05c65718&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c65718",
  null
  
)

export default component.exports